import React, { CSSProperties } from 'react';

import { RadioButton } from 'common/components/form/RadioButton/RadioButton';
import { ListWrapper } from 'common/components/form/RadioButton/RadioButton.styled';
import { useFormikField } from 'common/components/form/useFormikField';
import { FieldWrapper } from 'common/components/form/Wrapper';
import { ISelectModel } from 'common/models';

interface IRadioButtonList<TValue> {
  name: string;
  label?: string;
  options?: ISelectModel<TValue>[];
  required?: boolean;
  disabled?: boolean;
  margin?: string;
  direction?: 'row' | 'column';
  labelStyle?: CSSProperties;
  onChange?: (selectedValue: ISelectModel<TValue>) => void;
}

function RadioButtonList<TValue>({
  name,
  label,
  options,
  required,
  disabled,
  margin,
  direction = 'row',
  labelStyle,
  onChange,
}: IRadioButtonList<TValue>) {
  const { error, setValue } = useFormikField(name);

  return (
    <FieldWrapper
      name={name}
      isRequired={required}
      isDisabled={disabled}
      error={error}
      label={label}
      margin={margin}
      labelStyle={labelStyle}
    >
      <ListWrapper $direction={direction} role="group">
        {options?.map(({ value, label: displayName, disabled: selectDisabled }) => (
          <RadioButton
            key={displayName}
            name={name}
            value={value}
            displayName={displayName}
            disabled={selectDisabled}
            onChange={() => {
              setValue(value);
              onChange && onChange({ value, label: displayName });
            }}
          />
        ))}
      </ListWrapper>
    </FieldWrapper>
  );
}

export { RadioButtonList };
